import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
import { Target, Sparkles, CheckCircle2, Users, Briefcase, TrendingUp, Building, Network, Shield } from 'lucide-react';
const missions = [{
  icon: Target,
  name: 'Attack-Path Report',
  desc: 'Find the top realistic paths across cloud, identity, SaaS, code, external exposure, and internal signals.'
}, {
  icon: Sparkles,
  name: 'AI App Validation',
  desc: 'Validate LLM apps, RAG, copilots, agents, and AI workflows for misuse, leakage, and unsafe access.'
}, {
  icon: CheckCircle2,
  name: 'Fix Verification',
  desc: 'Re-test remediated issues. Prove whether risk is actually closed.'
}, {
  icon: Users,
  name: 'Customer Security Review',
  desc: 'Generate evidence for enterprise customers, questionnaires, and trust conversations.'
}, {
  icon: Briefcase,
  name: 'Cyber Insurance Readiness',
  desc: 'Prepare evidence around validation, remediation history, control gaps, and risk reduction.'
}, {
  icon: TrendingUp,
  name: 'Executive Risk Brief',
  desc: 'Translate validation results into plain-English business risk and action plans.'
}, {
  icon: Building,
  name: 'MSSP Client Report',
  desc: 'Client-ready summaries, remediation plans, QBR content, and proof of security progress.'
}, {
  icon: Network,
  name: 'Internal Exposure Review',
  desc: 'Use an optional internal runner to validate reachability and risky internal paths.'
}, {
  icon: Shield,
  name: 'Control Validation',
  desc: 'Safely test whether controls detect, block, or miss defined validation activity.'
}];
export function Missions() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-618">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-619">
        <SectionLabel number="13" label="Missions" className="mb-8" data-id="element-620" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-621">
          <div className="lg:col-span-8" data-id="element-622">
            <SectionHeading size="xl" data-id="element-623">
              Choose a mission.
              <br data-id="element-624" />
              <span className="text-white/40" data-id="element-625">Get proof.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-626">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-627">
              Periscan organizes security work into validation missions —
              focused workflows that produce specific evidence.
            </p>
          </div>
        </div>

        {/* Mission bento */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-628">
          {missions.map((m, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="group relative p-7 rounded-2xl bg-[#070a0e] border border-white/[0.06] hover:border-[#1a8fd4]/30 hover:bg-[#0a0d12] transition-all overflow-hidden" data-id="element-629">
              {/* Subtle glow on hover */}
              <div className="absolute -top-12 -right-12 w-32 h-32 bg-[#1a8fd4]/0 group-hover:bg-[#1a8fd4]/10 blur-2xl rounded-full transition-all" data-id="element-630" />

              <div className="relative flex items-start justify-between mb-6" data-id="element-631">
                <div className="w-11 h-11 rounded-xl bg-[#1a8fd4]/10 border border-[#1a8fd4]/20 flex items-center justify-center group-hover:bg-[#1a8fd4]/20 transition-colors" data-id="element-632">
                  <m.icon className="w-5 h-5 text-[#1a8fd4]" data-id="element-633" />
                </div>
                <span className="font-mono text-[10px] text-white/30" data-id="element-634">
                  M.{String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="relative text-xl font-semibold text-white mb-3 tracking-tight" data-id="element-635">
                {m.name}
              </h3>
              <p className="relative text-sm text-white/50 leading-relaxed" data-id="element-636">
                {m.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}